

<div class="container">
	<div class="row tex-center mb-6">
	  <div class="col-md-12">
		<iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fqueserafarm%2F&tabs=timeline&width=500&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=465793344843448" width="500" height="500" style="border:none;overflow:hidden; margin: 0 auto 0 auto;" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>	
	  </div>
	</div>
</div>